import { Box, ButtonBase, Hidden, useMediaQuery } from '@material-ui/core'
import React, { useState } from 'react'
import styled from 'styled-components'
import coversrcDeskAnticuerpo from '../../../assets/cover3.png'
import coversrcCovid from '../../../assets/coverCovid.png'
import coverMobileAnticuerpo from '../../../assets/coverMobile.png'
import covidmovile from '../../../assets/covidmovile.png'
import antigeno from '../../../assets/antigeno.png'
import antigenoMobile from '../../../assets/antigenoSmall.png'
import post from '../../../assets/new.png'
import postm from '../../../assets/newm.png'
import pcrIcon from '../../../assets/pcr.png'
import postVaccineIcon from '../../../assets/postIcon.png'
import unnamed from '../../../assets/unnamed.png'
import Container from '../../components/layout_micro/container'
import ContainerSecondary from './containerSecondary'
import { useHistory } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import SwipeableViews from 'react-swipeable-views'
import { autoPlay } from 'react-swipeable-views-utils'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews)

const FullWidthLaer = styled.div`
  padding: 1px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  height: 100%;
`
const Title = styled.div`
  font-size: 3.2em;
  font-family: 'imlbold'; font-weight: bold;
  color: var(--first);
  line-height: 1em;
  margin: 1.5em auto -.2em auto;
  @media screen and (max-width: 1400px) {
    margin: 1.2em auto -.1em auto;
  }
`

const Price = styled.div`
  font-size: 3.8em;
  font-family: 'imlbold'; font-weight: bold;
  color: var(--second);
  vertical-align: center;
  span {
    font-size: .65em;
  }
`
const ButtonStyle = styled.div`
  background: var(--first);
  padding: .2em 1em;
  font-size: 1.5em;
  font-family: 'imlmedium';
  color: #fff;
  border-radius: 50px;
  margin: .5em 0px 2.8em 0px;
  @media screen and (max-width: 1400px) {
    margin: .5em 0px 2em 0px;
  }
  @media screen and (max-width: 600px) {
    font-size: 1.2em;
  }
`
const BoxGradient = styled.div`
  background: rgb(255,255,255);
  background: linear-gradient(90deg,rgba(255,255,255,-0.103204) 0%,rgba(255,255,255,1) 50%,rgba(255,255,255,0) 100%);
  font-family: 'imlmedium';
`
const GradientTitle = styled.div`
  font-size: 1.4em;
  color: var(--first);
`

const ListMetthods = styled.div`
  display: flex;
  justify-content: center;
  margin-top: .2em;
  align-items: center;
`
const ListMetthodsItems = styled.div`
  font-size: 1.7em;
  font-family: 'imlbold'; font-weight: bold;
  color: var(--second);
  margin-right: .8em;
  padding-right: .8em;
  border-right: 4px solid var(--second);
  line-height: 1em;
  @media screen and (max-width:600px) {
    margin-right: .3em;
    padding-right: .3em;
    font-size: 1.1em;
    border-right: 2px solid var(--second);
    text-align: center;
    width: 33.3%;
    padding: 0em 1em;
    margin-right: 0em;
  }
  :last-of-type {
    margin-right: 0px;
    padding-right: 0px;
    border-right: 0px;
  }
`
const Footer = styled.div`
  margin-top: 1em;
  margin-bottom: 1em;
  font-size: 1.15em;
  color: var(--first);
  line-height: 1.2em;
  font-family: 'imlmedium';
  @media screen and (max-width: 1400px) {
    margin-top: 4em;
  }
  @media screen and (max-width: 600px) {
    margin-top: 1.3em;
    font-size: 1em;
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 2em 0px;
`

const BUttonSRed = styled(ButtonBase)`
  font-size: .9em;
  background-color: #fa5c66;
  cursor: pointer;
  margin-right: 1.5em;
  display: block;
  height: 45px;
  color: #fff;
  border-radius: 34px;
  line-height: 1em;
  padding: 0px 30px;
  @media screen and (max-width:600px) {
    padding: 0px 5px;
    height: 35px;
    margin-right: .55em;
    font-size: .8em;
  }
`

const SubText = styled.div`
  font-size: 1.8em;
  margin-top: .7em;
  color: var(--first)!important;
`

const IcontTitle = styled.img`
  width: .9em;
  margin-right: .5em;
  @media screen and (max-width:600px) {
    display: none;
  }
`

const Cover = props => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const [activeStep, setActiveStep] = useState(0)
  const history = useHistory()

  const handleScroll = element => {
    try {
      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <AutoPlaySwipeableViews index={activeStep} onChangeIndex={setActiveStep} enableMouseEvents disableLazyLoading interval={13000}>
      <FullWidthLaer style={{ backgroundImage: `url(${isMobile ? covidmovile : coversrcCovid})` }}>
        <Container id='init'>
          <ContainerSecondary>
            <Title> <IcontTitle src={pcrIcon} />Prueba PCR <Hidden smUp><br /></Hidden> COVID 19 </Title>
            <SubText>Prueba diagnóstica de Biología Molecular que determina si la persona tiene el virus SARS-CoV-2.</SubText>
            <Price> <span>$</span>1,750<span>.00</span> </Price>
            <Box display='flex'>
              <ButtonStyle>Entrega de resultados el mismo día(*)</ButtonStyle>
            </Box>
            <Box display='flex'>
              <BoxGradient>
                <GradientTitle>
                  Conoce nuestros tres tipo de servicios:
                </GradientTitle>
                <ListMetthods>
                  <ListMetthodsItems>
                    Módulo de Atención Externa
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Toma a domicilio
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Empresas
                  </ListMetthodsItems>
                </ListMetthods>
              </BoxGradient>
            </Box>
            <ButtonsContainer>
              <BUttonSRed onClick={event => history.push('/appointment#init')}>
                AGENDA TU CITA EN <Hidden xsDown> <br /></Hidden>
                MÓDULO DE ATENCIÓN EXTERNA
              </BUttonSRed>
              <BUttonSRed onClick={event => history.push('/')}>
                TIENDA EN LÍNEA
              </BUttonSRed>
              <HashLink style={{ textDecoration: 'none' }} to='/appointment#indications' smooth scroll={handleScroll}>
                <BUttonSRed>
                  INDICACIONES PARA <Hidden xsDown><br /></Hidden> LA TOMA EN MÓDULO EXTERNO
                </BUttonSRed>
              </HashLink>
            </ButtonsContainer>
            <Footer>
              (*) Entrega de resultados el mismo día si la toma de muestra es realizada entre <b>7:00 am</b> y <b>11:30 am</b>.<br />
              (*) Si la toma de muestra se realiza después de las <b>11:30 am</b> se entregarán los resultados al día hábil siguiente a las <b>7:00 pm</b>.
            </Footer>
          </ContainerSecondary>
        </Container>
      </FullWidthLaer>

      <FullWidthLaer style={{ backgroundImage: `url(${isMobile ? coverMobileAnticuerpo : coversrcDeskAnticuerpo})` }}>
        <Container id='init'>
          <ContainerSecondary>
            <Title><IcontTitle src={unnamed} />Prueba de Anticuerpos IgG e IgM COVID 19 </Title>
            <SubText>Prueba serológica cualitativa para la detección de anticuerpos IgM (infección activa) e IgG (de memoria) contra el virus SARS-CoV-2.</SubText>
            <Price> <span>$</span>550<span>.00</span> </Price>
            <Box display='flex'>
              <ButtonStyle>Entrega de resultados el mismo día(*)</ButtonStyle>
            </Box>
            <Box display='flex'>
              <BoxGradient>
                <GradientTitle>
                  Conoce nuestros tres tipo de servicios:
                </GradientTitle>
                <ListMetthods>
                  <ListMetthodsItems>
                    Módulo de Atención Externa
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Toma a domicilio
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Empresas
                  </ListMetthodsItems>
                </ListMetthods>
              </BoxGradient>
            </Box>
            <ButtonsContainer>
              {/* <BUttonSRed onClick={event => history.push('/appointment#init')}>
                AGENDA TU CITA EN <Hidden xsDown> <br /></Hidden>
                MÓDULO DE ATENCIÓN EXTERNA
              </BUttonSRed> */}
              <BUttonSRed onClick={event => history.push('/')}>
                TIENDA EN LÍNEA
              </BUttonSRed>
              {/* <HashLink style={{ textDecoration: 'none' }} to='/appointment#indications' smooth scroll={handleScroll}>
                <BUttonSRed>
                  INDICACIONES PARA <Hidden xsDown><br /></Hidden> LA TOMA EN MÓDULO EXTERNO
                </BUttonSRed>
              </HashLink> */}
            </ButtonsContainer>
            <Footer>
              (*) Entrega de resultados en 30 minutos, una vez tomada la prueba.<br />
              (*) Consultar horarios para toma de muestra al WhatsApp 4428173500.
            </Footer>
          </ContainerSecondary>
        </Container>
      </FullWidthLaer>

      <FullWidthLaer style={{ backgroundImage: `url(${isMobile ? antigenoMobile : antigeno})` }}>
        <Container id='init'>
          <ContainerSecondary>
            <Title><IcontTitle src={pcrIcon} />Prueba de Antígeno COVID 19</Title>
            <SubText>Prueba diagnóstica cualitativa que detecta el antígeno (proteína de la nucleocápside) del virus de SARS-CoV-2.</SubText>
            <Price> <span>$</span>450<span>.00</span> </Price>
            <Box display='flex'>
              <ButtonStyle>Entrega de resultados el mismo día(*)</ButtonStyle>
            </Box>
            <Box display='flex'>
              <BoxGradient>
                <GradientTitle>
                  Conoce nuestros tres tipo de servicios:
                </GradientTitle>
                <ListMetthods>
                  <ListMetthodsItems>
                    Módulo de Atención Externa
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Toma a domicilio
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Empresas
                  </ListMetthodsItems>
                </ListMetthods>
              </BoxGradient>
            </Box>
            <ButtonsContainer>
              {/* <BUttonSRed onClick={event => history.push('/appointment#init')}>
                AGENDA TU CITA EN <Hidden xsDown> <br /></Hidden>
                MÓDULO DE ATENCIÓN EXTERNA
              </BUttonSRed> */}
              <BUttonSRed onClick={event => history.push('/')}>
                TIENDA EN LÍNEA
              </BUttonSRed>
              {/* <HashLink style={{ textDecoration: 'none' }} to='/appointment#indications' smooth scroll={handleScroll}>
                <BUttonSRed>
                  INDICACIONES PARA <Hidden xsDown><br /></Hidden> LA TOMA EN MÓDULO EXTERNO
                </BUttonSRed>
              </HashLink> */}
            </ButtonsContainer>
            <Footer>
              (*) Entrega de resultados en 30 minutos, una vez tomada la prueba.<br />
              (*) Consultar horarios para toma de muestra al WhatsApp 4428173500.
            </Footer>
          </ContainerSecondary>
        </Container>
      </FullWidthLaer>

      <FullWidthLaer style={{ backgroundImage: `url(${isMobile ? postm : post})`, backgroundPosition: 'right' }}>
        <Container id='init'>
          <ContainerSecondary>
            <Title><IcontTitle src={postVaccineIcon} />PRUEBA DE ANTICUERPOS COVID-19 POST VACUNA</Title>
            <SubText>Verifica si tu sistema inmune ya desarrolló anticuerpo post vacunación.</SubText>
            <Price> <span>$</span>930<span>.00</span> </Price>
            <Box display='flex'>
              <ButtonStyle>Entrega de resultados el mismo día(*)</ButtonStyle>
            </Box>
            <Box display='flex'>
              <BoxGradient>
                <GradientTitle>
                  Conoce nuestros tres tipo de servicios:
                </GradientTitle>
                <ListMetthods>
                  <ListMetthodsItems>
                    Módulo de Atención Externa
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Toma a domicilio
                  </ListMetthodsItems>
                  <ListMetthodsItems>
                    Empresas
                  </ListMetthodsItems>
                </ListMetthods>
              </BoxGradient>
            </Box>
            <ButtonsContainer>
              {/* <BUttonSRed onClick={event => history.push('/appointment#init')}>
                AGENDA TU CITA EN <Hidden xsDown> <br /></Hidden>
                MÓDULO DE ATENCIÓN EXTERNA
              </BUttonSRed> */}
              <BUttonSRed onClick={event => history.push('/')}>
                TIENDA EN LÍNEA
              </BUttonSRed>
              {/* <HashLink style={{ textDecoration: 'none' }} to='/appointment#indications' smooth scroll={handleScroll}>
                <BUttonSRed>
                  INDICACIONES PARA <Hidden xsDown><br /></Hidden> LA TOMA EN MÓDULO EXTERNO
                </BUttonSRed>
              </HashLink> */}
            </ButtonsContainer>
            <Footer>
              (*) Entrega de resultados en 30 minutos, una vez tomada la prueba.<br />
              (*) Consultar horarios para toma de muestra al WhatsApp 4428173500.
            </Footer>
          </ContainerSecondary>
        </Container>
      </FullWidthLaer>
    </AutoPlaySwipeableViews>

  )
}

export default Cover
